<template>
    <div name="navigation" class="navigation" :class="{ fixed: isFixed }">
        <div class="header">
            <div class="header-inner">
                <h1 class="logo-wrap">
                    <a href="https://soldoc.co.kr/partners">
                        <img
                            src="../../assets/partners_mobile/logo.png"
                            alt="soldoc+"
                            class="img-logo"
                        />
                        <img
                            src="../../assets/partners_mobile/logo_blue.png"
                            alt="soldoc+"
                            class="img-fixed"
                        />
                    </a>
                </h1>
                <div class="wrapper">
                    <a
                        href="https://partner.soldoc.co.kr/"
                        class="btn btn-join"
                        target="_blank"
                        title="새 창 열림"
                        ><span>솔루션 가입하기</span></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "navigation",
    data() {
        return {
            isBannerVisible: true,
            isFixed: false,
            navTop: 100,
        };
    },
    mounted: function() {
        this.navTop = this.$el.offsetTop;
        window.addEventListener("scroll", this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll);
    },
    methods: {
        closeBanner() {
            this.isBannerVisible = false;
        },
        handleScroll() {
            this.navTop = this.$el.offsetTop;
            const currentScrollTop = window.scrollY;
            const currentHeight = window.innerHeight * 1;

            if (currentScrollTop > currentHeight) {
                this.isFixed = window.scrollY >= this.navTop;
            } else {
                this.isFixed = false;
            }
        },
    },
};
</script>

<style scoped>
.navigation {
    position: relative;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 56px;
    background: transparent;
    text-align: center;
    z-index: 200;
    display: none;
}
.navigation.fixed {
    display: flex;
}
.navigation.fixed .header-inner {
    justify-content: space-between;
}
.navigation.fixed .header {
    position: fixed;
    top: 0;
    height: 56px;
    background: #fff;
}
.navigation .logo-wrap .img-fixed {
    display: none;
}
.navigation.fixed .logo-wrap .img-logo {
    display: none;
}
.navigation.fixed .logo-wrap .img-fixed {
    display: block;
}
.navigation.fixed .btn-join {
    background: #008def;
    color: #fff;
}
.navigation.fixed .btn-join:hover {
    border: 1px solid #008def;
    background: #fff;
    color: #008def;
}
.navigation .header {
    width: 100%;
    height: 100%;
    text-align: center;
}
.navigation .header-inner {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    margin: 0 auto;
    padding: 0 34px;
}
.navigation .logo-wrap {
    width: 71px;
    height: 100%;
    margin: 0;
}
.navigation .logo-wrap a {
    display: flex;
    align-items: center;
    height: 100%;
}
.navigation .logo-wrap img {
    width: 100%;
    height: auto;
    object-fit: contain;
}
.navigation .btn-join {
    display: inline-flex;
    min-width: 100px;
    height: 34px;
    padding: 4px 20px;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    border: 1px solid #fff;
    background: transparent;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    text-align: center;
    color: #fff;
}
.navigation .btn-join:hover,
.navigation .btn-join:focus {
    background: #fff;
    color: #008def;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile_partners/Navigation.vue